export default function uuid() {
  return (
    'xxxxxxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
      const r = (Math.random() * 16) | 0;
      return r.toString(16);
    }) + `-${Date.now()}`
  );
}
